import React, { memo } from "react";

const DoneIcon: React.FC = memo(() => {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.7314 4.69042L7.10899 0.160356C7.21229 0.0534521 7.33497 0 7.47701 0C7.61906 0 7.74174 0.0534521 7.84504 0.160356C7.94835 0.267261 8 0.394209 8 0.541203C8 0.688196 7.94835 0.815145 7.84504 0.922049L3.09298 5.83964C2.98967 5.94655 2.86915 6 2.7314 6C2.59366 6 2.47314 5.94655 2.36983 5.83964L0.14876 3.5412C0.0454546 3.4343 -0.00404614 3.30735 0.000258264 3.16036C0.00456267 3.01336 0.0583678 2.88641 0.161674 2.77951C0.264979 2.67261 0.387655 2.61915 0.5297 2.61915C0.671746 2.61915 0.794421 2.67261 0.897727 2.77951L2.7314 4.69042Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { DoneIcon };
